import BaseMapper from '../../BaseMapper';

const MainOutcomeDescriptionMapper = (data, context) => {
    return data;
};

export default MainOutcomeDescriptionMapper;
